import {
  container,
  defaultFont,
  primaryColor,
  infoColor,
} from "assets/jss/realtimeWidget.js";

const headerStyle = {
  appBar: {
    display: "flex",
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "20px",
    color: "#555",
    width: "100%",
    backgroundColor: "#fff",
    boxShadow:
      "0 4px 18px 0px rgba(0, 0, 0, 0.12), 0 7px 10px -5px rgba(0, 0, 0, 0.15)",
    transition: "all 150ms ease 0s",
    alignItems: "center",
    flexFlow: "row nowrap",
    justifyContent: "flex-start",
    position: "relative",
  },
  absolute: {
    position: "absolute",
    zIndex: "1100"
  },
  fixed: {
    position: "fixed",
    zIndex: "1100"
  },
  container: {
    ...container,
    maxWidth: "100% !important",
    minHeight: "50px",
    flex: "1",
    alignItems: "center",
    justifyContent: "space-between",
    display: "flex",
    flexWrap: "nowrap",
    paddingLeft: "40px"
  },
  flex: {
    display: "flex",
    flex: 1,
    "@media (max-width: 600px)": {
      justifyContent: "center",
    },
    "@media (min-width: 600px)": {
      justifyContent: "center",
    },
    "@media (min-width: 960px)": {
      justifyContent: "space-between",
    },
    "@media (min-width: 1280px)": {
      justifyContent: "space-between",
    },
    "@media (min-width: 1920px)": {
      justifyContent: "space-between",
    }
  },
  overAll: {
    zIndex: "9999"
  },
  facilityTitle: {
    marginTop: "auto",
    marginBottom: "auto",
    "@media (max-width: 960px)": {
      display: "none",
    },
  },
  title: {
    ...defaultFont,
    lineHeight: "30px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    padding: "8px 0px",
    letterSpacing: "unset",
    "&:hover,&:focus": {
      color: "inherit",
      background: "transparent"
    }
  },
  appResponsive: {
    margin: "20px 10px"
  },
  primary: {
    backgroundColor: primaryColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(156, 39, 176, 0.46)"
  },
  info: {
    backgroundColor: infoColor,
    color: "#FFFFFF",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(0, 188, 212, 0.46)"
  },
  transparent: {
    backgroundColor: "transparent !important",
    boxShadow: "none",
    paddingTop: "25px",
    color: "#FFFFFF"
  },
  dark: {
    color: "#FFFFFF",
    backgroundColor: "#212121 !important",
    boxShadow:
      "0 4px 20px 0px rgba(0, 0, 0, 0.14), 0 7px 12px -5px rgba(33, 33, 33, 0.46)"
  },
  white: {
    border: "0",
    padding: "0.625rem 0",
    marginBottom: "0px",
    color: "#555",
    backgroundColor: "#fff !important",
    borderBottom: "1px solid #e3e3e3"
  },
  buttonLanguage: {
    marginLeft: "20px",
    fontSize: "0.5rem"
  }
};

export default headerStyle;
